<template>
    <div class="notes__empty">
        <div class="picture">
            <MaltIllustration name="notes-paperclip--high" alt="" width="170" />
        </div>
        <p class="joy-font-secondary-200">
            {{ $t('profile.vetting.drawer.tab.profile.notes.empty.title') }}
        </p>
        <p class="joy-font-size-primary-400">
            {{ $t('profile.vetting.drawer.tab.profile.notes.empty.subtitle') }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import {MaltIllustration} from '#components';
</script>

<style scoped lang="scss">
    .notes {
        &__empty {
            p {
                margin: 0;
            }

            text-align: center;
            margin: 20px auto;

            .picture {
                margin: 0 auto;
                margin-bottom: 20px;
            }
        }
    }
</style>
